/* Boardsmith 2026 product page: quick buy, Engrave shortcut, "Customize your board?" prompt.
   Uses event delegation because Dawn re-renders the variant picker on every option change. */
(function () {
  var PROMPT_KEY = 'bs-customize-prompt-dismissed';

  function realAddButton() { return document.querySelector('product-form button[type="submit"][name="add"]'); }
  function engravingTarget() {
    var heads = document.querySelectorAll('.gpo-app .gpo-heading');
    for (var i = 0; i < heads.length; i++) if (/engrav/i.test(heads[i].textContent)) return heads[i];
    return null;
  }
  // On desktop the details column scrolls on its own (sticky, overflow auto), so scroll that box, not the page.
  function scrollBox(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
    }
    return null;
  }
  function scrollToEl(el) {
    if (!el) return;
    var box = scrollBox(el);
    if (box) box.scrollTo({ top: box.scrollTop + el.getBoundingClientRect().top - box.getBoundingClientRect().top - 24, behavior: 'smooth' });
    else window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 24, behavior: 'smooth' });
    el.classList.add('bs-flash'); setTimeout(function () { el.classList.remove('bs-flash'); }, 1600);
  }
  // Has the shopper changed anything from the defaults? (rows: first option = "No …"; Globo: any "Yes")
  function customized() {
    var changed = false;
    document.querySelectorAll('.bs-opt--rows').forEach(function (fs) {
      var first = fs.querySelector('input[type="radio"]');
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (first && checked && first !== checked) changed = true;
    });
    document.querySelectorAll('.gpo-app .gpo-swatches.buttons input:checked').forEach(function (inp) {
      var label = inp.nextElementSibling;
      if (label && /^\s*yes\s*$/i.test(label.textContent)) changed = true;
    });
    return changed;
  }
  // Each customization the board offers: its name, a thumbnail (the ⓘ card photo, or Globo's engraving-zone image)
  // and the element to scroll to when it's picked in the prompt.
  function availableCustomizations() {
    var list = [];
    document.querySelectorAll('.bs-opt--rows').forEach(function (fs) {
      var l = fs.querySelector('legend'); if (!l) return;
      var img = fs.querySelector('.bs-tip img');
      list.push({ name: l.textContent.replace(/\s*\(.*?\)\s*/g, '').replace(/^add\s+/i, '').trim(), img: img && img.src, target: fs });
    });
    var eng = engravingTarget();
    if (eng) {
      var group = eng.closest('.gpo-group') || eng.parentElement;
      var eimg = group && group.querySelector('.gpo-paragraph img, img');
      list.push({ name: 'Engraving', img: eimg && (eimg.currentSrc || eimg.src), target: eng });
    }
    var feet = null;
    document.querySelectorAll('.gpo-app .gpo-label').forEach(function (l) {
      var t = (l.querySelector('.label-content') || l).textContent.trim();
      if (!feet && /feet/i.test(t)) feet = l;
    });
    if (feet) {
      var fimg = (feet.closest('.gpo-element') || document).querySelector('.bs-tip img');
      list.push({ name: 'Board feet', img: fimg && fimg.src, target: feet });
    }
    return list;
  }

  function openPrompt(onNoThanks) {
    var items = availableCustomizations();
    var dlg = document.getElementById('BsCustomizePrompt');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.id = 'BsCustomizePrompt';
      dlg.className = 'bs-dialog';
      dlg.setAttribute('aria-labelledby', 'BsCustomizePromptTitle');
      document.body.appendChild(dlg);
    }
    dlg.innerHTML =
      '<button type="button" class="bs-dialog__close" data-close aria-label="Close">×</button>' +
      '<p class="bs-eyebrow">Before you add it</p>' +
      '<h2 class="bs-h4" id="BsCustomizePromptTitle">Customize your board?</h2>' +
      '<p class="bs-p2">Make it yours. Tap one to set it up, or add the board as it is:</p>' +
      '<ul class="bs-dialog__list"></ul>' +
      '<div class="bs-dialog__actions">' +
        '<button type="button" class="bs-btn bs-btn--dark" data-customize>Customize my board</button>' +
        '<button type="button" class="bs-btn bs-btn--outline" data-nothanks>No thanks, add to cart</button>' +
      '</div>';
    var ul = dlg.querySelector('ul');
    items.forEach(function (it) {
      var li = document.createElement('li');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'bs-dialog__opt';
      if (it.img) { var im = document.createElement('img'); im.src = it.img; im.alt = ''; im.width = 56; im.height = 56; im.loading = 'lazy'; b.appendChild(im); }
      var nm = document.createElement('span'); nm.textContent = it.name; b.appendChild(nm);
      b.onclick = function () { dlg.close(); scrollToEl(it.target); };
      li.appendChild(b); ul.appendChild(li);
    });
    dlg.querySelector('[data-close]').onclick = function () { dlg.close(); };
    dlg.querySelector('[data-customize]').onclick = function () {
      dlg.close();
      scrollToEl(document.querySelector('.bs-customize-head') || engravingTarget());
    };
    dlg.querySelector('[data-nothanks]').onclick = function () {
      try { sessionStorage.setItem(PROMPT_KEY, '1'); } catch (e) {}
      dlg.close(); onNoThanks();
    };
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    if (typeof dlg.showModal === 'function') dlg.showModal(); else onNoThanks();
  }

  document.addEventListener('click', function (e) {
    var engrave = e.target.closest('[data-bs-engrave]');
    if (engrave) { scrollToEl(engravingTarget()); return; }

    var quick = e.target.closest('[data-bs-quickadd]');
    if (!quick) return;
    var add = realAddButton();
    if (!add) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(PROMPT_KEY) === '1'; } catch (err) {}
    var hasOptions = availableCustomizations().length > 0;
    if (hasOptions && !dismissed && !customized()) openPrompt(function () { add.click(); });
    else add.click();
  });

  // Show the Engrave shortcut only when Globo's engraving block is on the page (it loads after the picker).
  function syncEngrave() {
    var has = !!engravingTarget();
    document.querySelectorAll('[data-bs-engrave]').forEach(function (b) { b.hidden = !has; });
  }
  syncEngrave();
  new MutationObserver(syncEngrave).observe(document.body, { childList: true, subtree: true });
})();

/* ⓘ tooltips on option rows (data from sections/bs-option-tooltips.liquid). Re-attached after Dawn re-renders the picker. */
(function () {
  var dataEl = document.getElementById('BsOptionTooltips');
  if (!dataEl) return;
  var tips = [];
  try { tips = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var uid = 0;
  var INFO = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 6.416c.583 0 1.056.473 1.056 1.056v4.222a1.056 1.056 0 0 1-2.112 0V7.472c0-.583.473-1.056 1.056-1.056Zm0-3.166a1.056 1.056 0 1 1 0 2.111 1.056 1.056 0 0 1 0-2.111Z" fill="currentColor"/></svg>';

  function findTip(name) {
    var n = name.toLowerCase();
    if (/^\s*no\s/.test(n)) return null;
    for (var i = 0; i < tips.length; i++) {
      var words = (tips[i].match || []).map(function (w) { return w.trim(); }).filter(Boolean);
      if (words.length && words.every(function (w) { return n.indexOf(w) !== -1; })) return tips[i];
    }
    return null;
  }

  function attach() {
    // Dawn option rows, plus Globo's add-on rows (e.g. Cutting Board Feet, shown as rows by bs-redesign.css).
    document.querySelectorAll('.bs-opt label, .bs-pdp .gpo-app .gpo-dropdown .dropdown-item label').forEach(function (label) {
      if (label.querySelector('.bs-tip')) return;
      var nameEl = label.querySelector('.bs-opt__name, .dropdown-item__value');
      if (!nameEl) return;
      var tip = findTip(nameEl.textContent);
      if (!tip) return;
      var id = 'bs-tip-' + (++uid);
      var btn = document.createElement('span');
      btn.className = 'bs-tip';
      btn.setAttribute('role', 'button'); btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-label', 'About ' + tip.title); btn.setAttribute('aria-describedby', id);
      btn.innerHTML = INFO;
      var pop = document.createElement('span');
      pop.className = 'bs-tip__pop'; pop.id = id; pop.setAttribute('role', 'tooltip');
      pop.innerHTML = (tip.image ? '<span class="bs-tip__img"><img src="' + tip.image + '" alt="" width="140" height="140"></span>' : '') +
        '<span class="bs-tip__body"><span class="bs-tip__title"></span><span class="bs-tip__text"></span></span>';
      pop.querySelector('.bs-tip__title').textContent = tip.title;
      pop.querySelector('.bs-tip__text').textContent = tip.text;
      btn.appendChild(pop);
      // Clicking the icon must not select the option (it sits inside the radio's label).
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(btn); });
      btn.addEventListener('keydown', function (e) { if (e.key === 'Escape') btn.classList.remove('is-open'); });
      nameEl.insertAdjacentElement('afterend', btn);
    });
  }
  function toggle(btn) {
    document.querySelectorAll('.bs-tip.is-open').forEach(function (t) { if (t !== btn) t.classList.remove('is-open'); });
    btn.classList.toggle('is-open');
  }
  // Taps on an ⓘ inside Globo's rows are caught at window capture, before any of Globo's own handlers, so they never choose that add-on.
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gpo-app .bs-tip');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    toggle(btn);
  }, true);
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.bs-tip.is-open').forEach(function (t) { if (!t.contains(e.target)) t.classList.remove('is-open'); });
  });
  attach();
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
})();

/* Quantity beside Add to cart, and Globo add-on prices shown like the option rows ("+$10" instead of "(+ $10.00 USD)").
   The quantity block keeps its id, so Dawn's variant updates still find it. */
(function () {
  function placeQuantity() {
    var qty = document.querySelector('.bs-pdp .product-form__quantity:not(.bs-qty)');
    if (!qty) return;
    var add = document.querySelector('.bs-pdp product-form .product-form__buttons > button[name="add"]');
    if (!add) return;
    qty.classList.add('bs-qty');
    add.parentNode.insertBefore(qty, add);
  }
  function tidyAddOns() {
    document.querySelectorAll('.bs-pdp .gpo-app .addOn').forEach(function (el) {
      var m = el.textContent.match(/^\s*\(\s*\+\s*([^\d\s]?)\s*([\d,]+)(?:\.(\d{2}))?\s*[A-Z]{0,3}\s*\)\s*$/);
      if (!m) return;
      var cents = m[3] && m[3] !== '00' ? '.' + m[3] : '';
      var text = '+' + (m[1] || '$') + m[2] + cents;
      if (el.textContent !== text) el.textContent = text;
    });
  }
  // Globo redraws the main price (base + add-ons) with its "money with currency" format ("$245.00 USD");
  // show it like every other price on the page: "$245", keeping real cents ("$24.50").
  function tidyMainPrice() {
    document.querySelectorAll('.bs-pdp .price .price-item, .bs-pdp .price .money').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent, n = t.replace(/\s*[A-Z]{3}\s*$/, '').replace(/\.00(?=\s*$)/, '');
      if (n !== t) el.textContent = n;
    });
  }
  // The offer card (snippets/bs-offer-card.liquid) states the offer, so hide the description paragraph that repeats it.
  function hideOfferLine() {
    var card = document.querySelector('.bs-pdp .bs-offer[data-bs-offer-trigger]');
    if (!card) return;
    var t = card.getAttribute('data-bs-offer-trigger');
    document.querySelectorAll('.bs-pdp .product__description p').forEach(function (p) {
      if (!p.hidden && p.textContent.toLowerCase().indexOf(t) !== -1) p.hidden = true;
    });
  }
  function run() { placeQuantity(); tidyAddOns(); tidyMainPrice(); hideOfferLine(); }
  run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();
